import { useState } from "react";
import { Link } from "react-router-dom";
import { TOOL_SEARCH_LAUNCH_PATH, TOOL_SEARCH_LAUNCH_URL } from "../lib/toolSearchInfo";
import { AdSenseSlot } from "./AdSenseSlot";
import { hideHomeHeroAdForWeek, isHomeHeroAdHidden, type ActiveHomeHeroAd } from "../lib/homeHeroAd";

export function HeroAdDismissBar({ onDismiss }: { onDismiss: (forWeek: boolean) => void }) {
  return <div className="fe-hero-ad-bar">
    <button type="button" onClick={() => onDismiss(true)}>일주일간 보지 않기</button>
    <button type="button" onClick={() => onDismiss(false)}>닫기</button>
  </div>;
}

export function useDismissedAd(version: string, hideKey: string) {
  const [dismissed, setDismissed] = useState(false);
  const [hiddenForWeek] = useState(() => isHomeHeroAdHidden(version, Date.now(), hideKey));
  function dismiss(forWeek: boolean) {
    if (forWeek) hideHomeHeroAdForWeek(version, Date.now(), hideKey);
    setDismissed(true);
  }
  return { show: !dismissed && !hiddenForWeek, dismiss };
}

export function HomeHeroAdCard({ ad }: { ad: ActiveHomeHeroAd }) {
  const { show, dismiss } = useDismissedAd(ad.updatedAt, ad.hideKey);
  if (!show) return null;
  return <article className="fe-hero-ad" aria-label={ad.altText} style={{ gridColumn: ad.placement === "wide" ? 1 : ad.placement === "third" ? 3 : 2 }}>
    <div className="fe-hero-ad-media">
      {ad.kind === "adsense" ? <AdSenseSlot format="vertical" /> : ad.linkUrl === TOOL_SEARCH_LAUNCH_URL ?
        <Link className="fe-hero-ad-link" to={TOOL_SEARCH_LAUNCH_PATH}>
          <img src={ad.imageUrl} alt={ad.altText} />
        </Link> :
        <a className="fe-hero-ad-link" href={ad.linkUrl} target="_blank" rel="noopener noreferrer">
          <img src={ad.imageUrl} alt={ad.altText} />
        </a>}
    </div>
    <HeroAdDismissBar onDismiss={dismiss} />
  </article>;
}
